<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">{{ $t('message.changeProfile') }}</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="submit">
              <v-text-field
                :label="$t('message.newUsername')"
                prepend-icon="mdi-account"
                v-model="newUsername"
                required
              ></v-text-field>
              <v-file-input
                prepend-icon="mdi-camera"
                accept="image/*"
                v-model="newProfile"
                :label="$t('message.profilePhoto')"
                @change="previewImage"
                :rules="profileRules"
                :hint="$t('message.profilePhotoHint')"
                persistent-hint
                :max-size="1048576"
              ></v-file-input>
              <v-text-field
                  :label="$t('message.email')"
                  prepend-icon="mdi-email"
                  v-model="email"
                  type="email"
                disabled
              ></v-text-field>
              <!-- 国家下拉框 -->
              <v-select
                  :items="countries"
                  :label="$t('message.country')"
                  v-model="country"
                  item-title="name"
                  item-value="code"
                  prepend-icon="mdi-earth"
                  required
                  :loading="loadingCountries"
                  :disabled="loadingCountries"
              ></v-select>

              <v-text-field
                  :label="$t('message.institution')"
                  prepend-icon="mdi-school"
                  v-model="institution"
                  required
              ></v-text-field>

              <v-text-field
                  :label="$t('message.field')"
                  prepend-icon="mdi-briefcase"
                  v-model="field"
                  required
              ></v-text-field>

              <v-btn color="primary" class="mt-4" block @click="submit">
                {{ $t('message.changeProfile') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for success message -->
    <v-snackbar
        v-model="snackbarSuccess"
        color="success"
        top
        multi-line
        timeout="3000"
    >
      {{ successMessage }}
      <v-btn color="white" text @click="snackbarSuccess = false">{{ $t('message.close') }}</v-btn>
    </v-snackbar>

    <!-- Snackbar for error message -->
    <v-snackbar
        v-model="snackbarError"
        color="error"
        top
        multi-line
        timeout="3000"
    >
      {{ errorMessage }}
      <v-btn color="white" text @click="snackbarError = false">{{ $t('message.close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  name: 'EditUsername',
  data() {
    return {
      newUsername: '',
      email:'',
      imageUrl:'',
      newProfile:'',
      snackbarSuccess: false,
      snackbarError: false,
      successMessage: '',
      errorMessage: '',
      country: null,
      institution: '',
      field: '',
      countries:[
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cabo Verde",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Comoros",
      "Congo",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Greece",
      "Grenada",
      "Guatemala",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Kosovo",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Micronesia",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Qatar",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Korea",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Vatican City",
      "Venezuela",
      "Vietnam",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],
      loadingCountries: false, // 加载状态
      // 头像文件验证规则
      profileRules: [
        value => {
          if (!value || value.length === 0) return true; // 允许不上传
          const file = Array.isArray(value) ? value[0] : value;
          if (!file || !file.name) return 'Please select a valid image file';
          
          // 检查文件类型
          const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
          if (!allowedTypes.includes(file.type)) {
            return 'Only JPG, PNG, GIF formats are supported';
          }
          
          // 检查文件大小 (1MB = 1 * 1024 * 1024 bytes)
          const maxSize = 1 * 1024 * 1024;
          if (file.size > maxSize) {
            return 'Image file size cannot exceed 1MB';
          }
          
          return true;
        }
      ],
    };
  },
  created() {
    this.loadInfo(); // 在组件创建时调用
  },
  mounted() {
    // this.fetchCountries(); // 页面加载时获取国家列表
  },
  beforeUnmount() {
    // 释放 ObjectURL，避免内存泄漏
    if (this.imgSrc && this.imgSrc.startsWith('blob:')) {
      URL.revokeObjectURL(this.imgSrc);
    }
  },
  methods: {
    // async fetchCountries() {
    //   this.loadingCountries = true;
    //   try {
    //     const response = await axios.get('https://restcountries.com/v3.1/all');
    //     this.countries = response.data
    //       .filter(country => country.cca2 !== 'TW') // 排除台湾
    //       .map(country => ({
    //         name: country.name.common,
    //         code: country.cca2,
    //       }));
    //     this.countries.sort((a, b) => a.name.localeCompare(b.name))
    //   } catch (error) {
    //     console.error('Failed to fetch countries:', error);
    //     this.snackbarError = true;
    //     this.errorMessage = 'Failed to load country list.';
    //   } finally {
    //     this.loadingCountries = false;
    //   }
    // },
    async loadInfo() {
      try {
        // 获取用户信息
        var data = new FormData();
        const access_token = localStorage.getItem('access_token');
        data.append('access_token', access_token);
        const response = await axios.post('/api/user/GetTokenInfoView/', data);

        console.log(response.data.username)
        console.log(response.data.img)

        // 设置用户基本信息
        this.newUsername = response.data.username
        this.field = response.data.field
        this.country = response.data.country
        this.institution = response.data.institution
        this.email = response.data.email

        // 使用新的头像接口获取头像（后端会自动处理默认头像）
        if (response.data.user_id) {
          try {
            const avatarResponse = await axios.post('/api/user/GetUserAvatar/', {
              user_id: response.data.user_id
            }, {
              responseType: 'blob'
            });

            // 释放旧的 ObjectURL（如果存在）
            if (this.imgSrc && this.imgSrc.startsWith('blob:')) {
              URL.revokeObjectURL(this.imgSrc);
            }

            // 将 blob 转换为 ObjectURL
            this.imgSrc = URL.createObjectURL(avatarResponse.data);
            console.log('用户头像加载成功');
          } catch (avatarError) {
            console.error('获取头像失败:', avatarError);
            // 后端应该会返回默认头像，所以这里一般不会失败
            this.imgSrc = null;
          }
        }
      } catch (error) {
        console.error('加载用户信息失败:', error.response ? error.response.data : error.message);
        this.errorMessage = error.response?.data?.msg || 'Failed to load user information. Please try again.';
        this.snackbarError = true;
      }
    },

    // 预览图片
    previewImage(event) {
      const file = event.target.files[0];
      if (file) {
        // 验证文件类型
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        if (!allowedTypes.includes(file.type)) {
          this.errorMessage = 'Only JPG, PNG, GIF formats are supported';
          this.snackbarError = true;
          // 清空文件输入
          event.target.value = '';
          this.newProfile = null;
          return;
        }
        
        // 验证文件大小
        const maxSize = 1 * 1024 * 1024; // 1MB
        if (file.size > maxSize) {
          this.errorMessage = 'Image file size cannot exceed 1MB';
          this.snackbarError = true;
          // 清空文件输入
          event.target.value = '';
          this.newProfile = null;
          return;
        }
        
        // 文件验证通过，创建预览URL
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    async submit() {
      try {
        var FormData = require('form-data');
        var data = new FormData();
        const access_token = localStorage.getItem('access_token');
        data.append('access_token', access_token);
        data.append('username', this.newUsername);
        data.append('img', this.newProfile);
        data.append('country', this.country);
        data.append('institution', this.institution);
        data.append('field', this.field);
        // Send the request to change the username
        await axios.post('/api/user/ChangeInfoView/', data,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
       });

        // Show success message
        this.successMessage = 'ImgView changed successfully!';
        this.snackbarSuccess = true;
        window.location.reload();
      } catch (error) {
        console.log(error)
        // Handle error
        console.error('Change ChangeImgView error:', error.response ? error.response.data : error.msg);
        this.errorMessage = error.response?.data?.msg || 'Failed to change username. Please try again.';
        this.snackbarError = true;
      }
    }
  }
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
